import React from 'react';
import axios from "axios";
import { TimelineMax, Power1 } from "gsap"
import styled from 'styled-components';

import Footer from "../components/shared/Footer";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const renderHTML = rawHTML => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

class ProjectInner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      project: {}
    }

    this.timeline = new TimelineMax({ paused: true });
  }

  componentDidMount() {
    const projectLink = this.props.match.params.projectLink;

    axios
      .get(`https://www.paralele.me/api/projects/index.php?link=${projectLink}&lang=${window.languageInt}`)
      .then(res => res.data)
      .then(data => {
        this.setState({ project: data })
      })

    this.timeline
      .from(this.leftContent, {
        autoAlpha: 0,
        y: 15,
        ease: Power1.ease
      })
      .from(this.rightContent, {
        autoAlpha: 0,
        y: 10,
        ease: Power1.ease
      })

    this.timeline.play();
  }

  render() {
    const { name, text, gallery_images } = this.state.project;
    return (
      <>
        <div className="container">
          {/* <BackNav><Link to="/">Go back</Link></BackNav> */}
          <div className="row">
            <div className="col-md-4" ref={leftContent => (this.leftContent = leftContent)}>
              <Heading>{name}</Heading>
              {renderHTML(text)}
            </div>
            <div className="col-md-8" ref={rightContent => (this.rightContent = rightContent)}>
              <ImagesWrapper>
                {gallery_images &&
                  gallery_images.map(image => {
                    return <LazyLoadImage key={image.id} src={image.link} alt="Image 1" effect="blur" placeholderSrc={image.placeholder_link} />
                  })
                }
              </ImagesWrapper>
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }

}

const ImagesWrapper = styled.div`
  margin-top: 40px;

  @media(min-width: 992px) {
    margin-top: 0;
  }
  
  img {
    max-width: 100%;
    margin-bottom: 25px;
  }
`

const Heading = styled.h1`
  font-weight: 400;
  font-size: 24px;
  margin-bottom: 25px;
  line-height: 1

  @media(min-width: 992px) {
    font-size: 32px;
    line-height: 1.5
  }
`

export default ProjectInner;